var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['message-abstract-image']},[_c('img',{class:['messageImage'],attrs:{"src":_vm.messageContent.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }